import 'moment/locale/th';
import 'assets/vendors/style';
import './index.scss';

import { RouterProvider, createBrowserRouter, useLocation } from 'react-router-dom';

import { ConfigProvider } from 'antd';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Views from './views';
import { queryClient } from 'lib/react-query';
import styled from '@emotion/styled';
import thTH from 'antd/lib/locale/th_TH';
import { useEffect } from 'react';

const AppWrapper = () => {
  const { innerWidth } = window;
  const location = useLocation();

  return (
    <AppChangeBackGroundTheme
      className={location.pathname.startsWith('/app') ? 'app-provide' : 'auth-provide'}
      innerWidth={innerWidth}
    >
      <Views />
    </AppChangeBackGroundTheme>
  );
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <AppWrapper />,
  },
]);

function App() {
  useEffect(() => {
    document.body.classList.add('dark-theme');
    document.body.classList.add('kk-theme');
  }, []);

  return (
    <ConfigProvider locale={thTH}>
      <QueryClientProvider client={queryClient}>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ConfigProvider>
  );
}

export default App;

const AppChangeBackGroundTheme = styled.div`
  ${({ innerWidth }) => `
    height:100%;

    &.auth-provide {
      background-image: url('/img/welcome-bg.jpg');
      background-position: center;
      background-size:${innerWidth > 1600 ? 'contain' : 'cover'};

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
      }
    }

    &.app-provide {
      background-color: #5F4E4B;
    }
  `}
`;
